import { createBrowserHistory } from 'history';
import { captureAttributionFromLocation, getGaClientId, initMetaPixel, trackPageView } from './utils/analytics';

const history = createBrowserHistory();

// Capture attribution and ensure a stable GA client id as early as possible.
if (typeof window !== 'undefined') {
  captureAttributionFromLocation();
  getGaClientId();
  initMetaPixel();
}

history.listen(({ location }) => {
  trackPageView(location);
});

export default history;
